// Central map of dashboard section keys -> Material Symbols icon names.
//
// This replaces the old per-tenant SVG files (public/assets/tenants/<t>/images/*.svg).
// Every tenant now shares these icons; only the brand COLOUR differs, driven by
// the --brand-color CSS variable (set from each tenant's $primary-color).
//
// Icon names are Material Symbols (Outlined) — the same family the Flutter app
// uses — so the web and mobile dashboards match. Browse names at
// https://fonts.google.com/icons (style: "Outlined").
//
// To add a new dashboard section: add one line here. No image files needed.

export const SECTION_ICONS = {
  boot: "account_circle",        // Profile / Overview
  teams: "groups",               // Teams Information
  nutrition: "restaurant",       // Nutrition / Fuelling
  playerChange: "person_add",    // Trialists
  pitch: "calendar_month",       // Schedule
  strip: "sports",               // Coaches / Season rollover (whistle)
  ball: "person_search",         // Scouts
  clock: "fitness_center",       // Training plans / Personal training
  documentlib: "folder_open",    // Documents library
  chat: "chat_bubble",           // Chats
  matchReports: "assignment",    // Match reports
  gpsReports: "monitoring",      // GPS reports
  rtp: "directions_run",         // Return to play
  injuries: "healing",           // Injury reports
  physioCalendar: "event",       // Physio calendar
  physio: "medical_services",    // Book physio
  video: "play_circle",          // Video

  // Club Payments (Settings) section cards:
  stripeAccount: "account_balance", // Stripe account / bank connection
  feePlans: "request_quote", // Membership fee plans
  fundraising: "volunteer_activism", // Fundraising campaigns
  membersPayments: "receipt_long", // Members' payments treasurer view

  // Extra keys aligned with the Flutter dashboard, ready for future sections:
  teamFeed: "forum",
  attendance: "event_available",
  wellness: "monitor_heart",
  homework: "menu_book",
  performance: "insights",
  development: "flag",           // IDP
  appActivity: "query_stats",    // App Activity / usage adoption board
};

// Fallback icon if a key is missing from the map.
export const DEFAULT_SECTION_ICON = "widgets";

export function iconForSection(name) {
  return SECTION_ICONS[name] || DEFAULT_SECTION_ICON;
}
